/* eslint-disable */
export default {
  start: 'Een korte rondleiding',
  skip: 'Overslaan',
  next: 'Volgende',
  finish: 'Voltooien',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
